import React from 'react'
import { Button, useWalletModal } from '@pancakeswap/uikit'
import useAuth from '~/hooks/useAuth'
import { useTranslation } from '~/contexts/Localization'
import { ConnectButton } from '@rainbow-me/rainbowkit'
import { useNetwork } from 'wagmi'
import { SUPPORTED_CHAINS } from '~/config/constants/chains'

const ConnectWalletButton = (props) => {
  const { t } = useTranslation()
  const { login, logout } = useAuth()

  const { onPresentConnectModal } = useWalletModal(login, logout, t)

  if (props?.wrongNetwork) {
    return (<ConnectButton.Custom>
        {({
            openChainModal,
            authenticationStatus,
            mounted,
          }) => {
          const ready = mounted && authenticationStatus !== 'loading'

          return (
            <div
              {...(!ready && {
                'aria-hidden': true,
                'style': {
                  opacity: 0,
                  pointerEvents: 'none',
                  userSelect: 'none',
                },
              })}
            >
              {(() => {
                return (
                  <Button style={{ color: '#0c0032' }} onClick={openChainModal} type='button' {...props}>
                    Wrong Network
                  </Button>
                )
              })()}
            </div>
          )
        }}
      </ConnectButton.Custom>
    )
  }


  return (
    <ConnectButton.Custom>
      {({
          account,
          chain,
          openAccountModal,
          openChainModal,
          openConnectModal,
          authenticationStatus,
          mounted,
        }) => {
        // Note: If your app doesn't use authentication, you
        // can remove all 'authenticationStatus' checks

        const ready = mounted && authenticationStatus !== 'loading'
        const connected =
          ready &&
          account &&
          chain &&
          (!authenticationStatus ||
            authenticationStatus === 'authenticated')

        return (
          <div
            {...(!ready && {
              'aria-hidden': true,
              'style': {
                opacity: 0,
                pointerEvents: 'none',
                userSelect: 'none',
              },
            })}
          >
            {(() => {
              if (!connected) {
                return (
                  <Button style={{ color: '#0c0032' }} onClick={openConnectModal} type='button' {...props}>
                    Connect Wallet
                  </Button>
                )
              }

              // TODO remove it. this is not work as expected
              if (chain.unsupported) {
                return (
                  <Button style={{ color: '#0c0032' }} onClick={openChainModal} type='button' {...props}>
                    Wrong network
                  </Button>
                )
              }

              return (
                <div style={{ display: 'flex', gap: 12 }}>
                  <Button
                    onClick={openChainModal}
                    style={{ display: 'flex', color: '#0c0032', alignItems: 'center' }}
                    type='button'
                    {...props}
                  >
                    {chain.hasIcon && (
                      <div
                        style={{
                          background: chain.iconBackground,
                          width: 12,
                          height: 12,
                          borderRadius: 10,
                          overflow: 'hidden',
                          marginRight: 4,
                        }}
                      >
                        {chain.iconUrl && (
                          <img
                            alt={chain.name ?? 'Chain icon'}
                            src={chain.iconUrl}
                            style={{ width: 12, height: 12 }}
                          />
                        )}
                      </div>
                    )}
                    {chain.name}
                  </Button>

                  <Button style={{ color: '#0c0032' }} onClick={openAccountModal} type='button' {...props}>
                    {account.displayName}
                    {account.displayBalance
                      ? ` (${account.displayBalance})`
                      : ''}
                  </Button>
                </div>
              )
            })()}
          </div>
        )
      }}
    </ConnectButton.Custom>
  )
}

export default ConnectWalletButton
